import { SET_POLICY, SET_POLICY_KIND_INVESTMENT } from './mutations';
export const actions = {
    setPolicy({ commit }, payload) {
        commit(SET_POLICY, payload);
    },
    resetPolicy({ commit }) {
        commit(SET_POLICY_KIND_INVESTMENT, '');
        commit(SET_POLICY, {});
    },
    setPolicyKindInvestment({ commit }, payload) {
        commit(SET_POLICY_KIND_INVESTMENT, payload);
    },
};
